import { cr, URLS, mo } from "fire-wind-water";
import { $cmsData, settings } from "../common/setting";
import { scmsService } from "../services/site";
import { user } from "../user/index";
import * as $ from "jquery";
import { actionBrowse } from "../lifecycle/onInit/browse";

class Detail {
  $skelem = ".sk-cms-article-get";
  isPreview: boolean = settings.isPreview;
  isDesign: boolean = settings.isDesign;
  tid: string = settings.tenantId || URLS.getURL("tid") || window['siteParams'].tid;
  title = "";
  body = "";
  time = "";
  preview = "";
  status; // 1-已收藏 0-未收藏
  skAfterViewChecked(): void {
    if (!this.isDesign) {
      this.getStatus();
      this.browse();
      this.getDetail();
    }
    if (this.isPreview) {
      cr.each($cmsData.container, (item: { [label: string]: any }) => {
        cr.each(item, (d) => {
          if (d.type === "ARTICLEDETAIL") {
            this.body = d.historyContent.content.body;
            this.time = d.historyContent.content.time;
            this.title = d.historyContent.content.title;
          }
          if (d.type === "NAV") {
            if (d.historyContent.basic.style.type == "bottomNav") {
              $(".foot-button-wrap")
                .css(
                  "bottom",
                  "calc(18.2vw +  constant(safe-area-inset-bottom))"
                )
                .css("bottom", "calc(18.2vw +  env(safe-area-inset-bottom))");
            }
          }
        });
      });
    }
  }

  getDetail(): void {
    const aid = URLS.getURL("aid") || settings.objId;
    if (aid) {
      const params = {
        tenantId: this.tid,
        articleId: aid,
        globalUserId: user.globalUserId,
        sess: "",
        openId: "",
        isWithStat: 1,
        isScroll: 0,
        isWithTag: 0,
      };
      scmsService.getArticle(params).subscribe((res) => {
        if (res.result == 0) {
          this.body = res.content.content;
          this.time = mo(res.content.pushTime * 1000).format("YYYY-MM-DD");
          this.title = res.content.title;
          this.preview = res.content.statInfo.browseCount;
          document.title = this.title;
          // cr.each($cmsData.container, (item: { [label: string]: any }) => {
          //   cr.each(item, d => {
          //     if (d.type === 'ARTICLEDETAIL') {
          //       d.historyContent.content.body = res.content.content;
          //       d.historyContent.content.time = mo(res.content.pushTime * 1000).format('YYYY-MM-DD');
          //       d.historyContent.content.title = res.content.title;
          //     }
          //    // $renderComponent(d.historyContent, d.category);
          //     // this.skUpdateView();
          //   });
          // });
        }
        actionBrowse();
        $sk.loading.hide();
      });
    }
  }
  browse(): void {
    const aid = URLS.getURL("aid") || settings.objId;
    if (aid) {
      const params = {
        tenantId: this.tid,
        articleId: aid,
        globalUserId: user.globalUserId,
        sess: "",
        openId: "",
      };
      scmsService.browseArticle(params).subscribe((res) => {});
    }
  }
  getStatus(): void {
    const m = $sk.template.get();
    const params = {
      tenantId: this.tid,
      moduleId: 36,
      instanceId: (window as any).stemplateConfig.instanceId,
      objectModuleId: 26,
      objId: URLS.getURL("aid") || settings.objId,
      sess: m.user.session || "",
    };
    scmsService.getCollectStatus(params).subscribe((res) => {
      if (res && res.result === 0) {
        this.status = res.content.status;
        if (this.status == 1) {
          $("#btn-collect-icon").removeClass("icons-shoucang1");
          $("#btn-collect-icon").addClass("icons-shoucang2");
          $("#btn-collect").html("取消收藏");
        }
      }
    });
  }
  handelCollect(): void {
    if (this.status == 1) {
      this.cancelCollect();
    } else {
      this.saveCollect();
    }
  }
  saveCollect(): void {
    const m = $sk.template.get();
    if (!m.user.session) {
      $sk.confirm("您尚未登录，是否去登录？", {
        ok() {
          $sk.goto(
            URLS.updateParam(
              "backUrl",
              encodeURIComponent(window.location.href),
              settings.memberFormUrl
            )
          );
        },
      });
      return;
    }
    const params = {
      tenantId: this.tid,
      moduleId: 36,
      instanceId: (window as any).stemplateConfig.instanceId,
      objectModuleId: 26,
      objId: URLS.getURL("aid") || settings.objId,
      objTitle: this.title,
      sess: m.user.session || "",
      objUrl: window.location.href,
    };
    scmsService.saveCollect(params).subscribe((res) => {
      if (res && res.result === 0) {
        $sk.alert("收藏成功");
        $("#btn-collect").html("取消收藏");
        $("#btn-collect-icon").removeClass("icons-shoucang1");
        $("#btn-collect-icon").addClass("icons-shoucang2");
        this.status = 1;
      } else {
        $sk.alert(res.desc);
      }
    });
  }
  //   取消收藏
  cancelCollect(): void {
    const m = $sk.template.get();
    const params = {
      tenantId: this.tid,
      moduleId: 36,
      instanceId: (window as any).stemplateConfig.instanceId,
      objectModuleId: 26,
      objId: URLS.getURL("aid") || settings.objId,
      sess: m.user.session || "",
    };
    scmsService.delCollect(params).subscribe((res) => {
      if (res && res.result === 0) {
        $sk.alert("取消成功");
        $("#btn-collect").html("收藏");
        $("#btn-collect-icon").removeClass("icons-shoucang2");
        $("#btn-collect-icon").addClass("icons-shoucang1");
        this.status = 0;
      } else {
        $sk.alert(res.desc);
      }
    });
  }
}

export { Detail };
